import { fetchQueryApi } from 'api/fetchApi'
import { definitions, operations } from 'api/generated/seo'
import { NodeHeaders } from 'api/NodeHeaders'

export const fetchBreadCrumbsProfileApi = (
  userId: number,
  headers?: NodeHeaders
) => {
  return fetchQueryApi<
    definitions['SeoLink'][],
    operations['seo_user_breadcrumbs_getUserBreadcrumbs']['parameters']['query']
  >(
    '/seo/user-breadcrumbs',
    {
      userId,
    },
    {
      headers,
    }
  )
}
